import { render, staticRenderFns } from "./UserBanner.vue?vue&type=template&id=4b909c4e&scoped=true&"
import script from "./UserBanner.vue?vue&type=script&lang=js&"
export * from "./UserBanner.vue?vue&type=script&lang=js&"
import style0 from "./UserBanner.vue?vue&type=style&index=0&id=4b909c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b909c4e",
  null
  
)

export default component.exports